import styled from "styled-components";
import { formatHours } from "./format";

const Root = styled.span`
  font-variant-numeric: tabular-nums;
  white-space: nowrap;
`;

/**
 * Horas no padrão do design system: "12h30", "8h", "0h45" (nunca decimal). Recebe
 * `minutes` ou `hours` (decimal, como vem das horas de projeto: `hours={72.5}` → "72h30").
 */
export default function Hours({ minutes, hours, className }) {
  const total = minutes != null ? minutes : hours != null && hours !== "" ? Number(hours) * 60 : null;
  const text = formatHours(total);
  const m = text.match(/^(-?[\d.]+)h(\d*)$/);
  const label = m ? `${m[1]} horas${m[2] ? ` e ${Number(m[2])} minutos` : ""}` : undefined;
  return (
    <Root className={className} aria-label={label}>
      {text}
    </Root>
  );
}
